export default __webpack_public_path__ + "static/media/Outfit-VariableFont_wght.bc779fb1.ttf";